<base-support-modal [title]="title" [btnOkClass]="'btn-danger'" [btnOkLabel]="'Заблокировать'" (onOk)="ok()" >
	<p>Причины блокировки сайта:</p>
	<textarea name="message" [(ngModel)]="message" class="form-control" rows="3"></textarea>
	<br>
	<p>Пользователь получит письмо на email: <strong style="white-space: nowrap;">{{userEmail}}</strong></p>
</base-support-modal>
